import React from 'react';
import {Input} from "./Input";
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';


export class Date extends Input {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <label>{this.props.label}{this.props.required ? '*' : ''}</label>
                {this.props.helpText && (
                    <small className="form-text text-muted mb-1">{this.props.helpText}</small>
                )}
                <SingleDatePicker
                    date={this.state.value}
                    onDateChange={value => this.props.updateElement(this.props.name, value)}
                    focused={this.state.focused}
                    onFocusChange={({ focused }) => this.setState({ focused })}
                    id="single-date-picker"
                />
                <div className="invalid-feedback">
                    <ul className="errors">
                        {this.hasError() ? this.state.errors.map((error, index) => {
                            return <li key={index + 1}>{error}</li>
                        }) : ''}
                    </ul>
                </div>
            </React.Fragment>
        );
    }
}